import {} from '@oneaudi/unified-web-common';
import React from 'react';
import { StyledList } from './index.styles.js';
export const List = ({ children, className, 'data-testid': dataTestId, margin }) => (React.createElement(StyledList, { className: className, margin: margin, "data-testid": dataTestId }, children));
//# sourceMappingURL=index.js.map